<template>
  <div
      :class=" source === 'ShowFileComponent' ? 'video-player-container-normal' : source === 'onlineClassItem' ? 'video-player-assignment' : 'video-player-container-online-class'">
    <video ref="videoPlayer"
           :style="source === 'onlineClassItem' ?'min-height: 400px!important'  : source === 'lessonAssignment' ?  'min-height: 250px!important' :  'min-height: 400px!important'"
           crossorigin="anonymous"
           class="video-js vjs-fill"></video>
  </div>
</template>

<script>
import videojs from 'video.js';
import dynamicWatermark from 'videojs-dynamic-watermark';

export default {
  name: "VideoPlayer",
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    },
    source: {
      type: String
    },
    itemId: null
  },
  data() {
    return {
      player: null,
      windowWidth: 1000,
      maxAllowedTime: 0,
      isRestoringTime: false,
      lastApiCallTime: 0,
    }
  },
  mounted() {

    this.windowWidth = window.innerWidth
    videojs.registerPlugin('dynamicWatermark', dynamicWatermark)
    let myPlayer = this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady() {
    })
    let USER = this.$store.state.user
    if (this.$route.path !== '/') {
      myPlayer.dynamicWatermark({
            elementId: 'watermark-content',
            watermarkText: USER.name + '- دُرَک',
            changeDuration: 7000,
            cssText: 'display: inline-block; color: grey; background-color: transparent; font-size: 0.5rem; z-index: 9999; position: absolute; @media only screen and (max-width: 992px){font-size: 0.8rem;}'
          }
      )
    }


    if (this.itemId) {
      this.getLastTrack().then((lastSeconds) => {
        console.log('Last track retrieved, seconds:', lastSeconds);

        // Ensure `currentTime` is set only when metadata is loaded
        const setPlaybackTime = () => {
          if (lastSeconds > 0) {
            this.maxAllowedTime = Math.max(this.maxAllowedTime, Math.floor(lastSeconds));
            this.isRestoringTime = true;
            myPlayer.currentTime(lastSeconds); // Set the playback position
            this.$nextTick(() => {
              this.isRestoringTime = false;
            });
            console.log(`Playback starts at: ${lastSeconds} seconds`);
          }
        };

        // Check if metadata is already loaded
        if (myPlayer.readyState() > 0) {
          setPlaybackTime();
        } else {
          myPlayer.on('loadedmetadata', () => {
            setPlaybackTime();
          });
        }
      });
    }


    myPlayer.on('seeking', () => {
      this.preventForwardSeek(myPlayer);
    });

    myPlayer.on('ended', () => {
      this.lastApiCallTime = 0;
    });

    // Track playback time
    myPlayer.on('timeupdate', () => {
      if (this.isRestoringTime) {
        return;
      }

      const currentTime = myPlayer.currentTime(); // Get current playback time in seconds
      if (currentTime < this.lastApiCallTime - 2) {
        this.lastApiCallTime = 0;
      }

      if (currentTime > this.maxAllowedTime + 2) {
        this.preventForwardSeek(myPlayer);
        return;
      }

      this.maxAllowedTime = Math.max(this.maxAllowedTime, Math.floor(currentTime));

      // Check if at least 10 seconds have passed
      if (this.itemId && Math.floor(currentTime) - this.lastApiCallTime >= 10) {
        this.lastApiCallTime = Math.floor(currentTime); // Update the last API call time
        console.log(`API Called at time: ${Math.floor(currentTime / 60)} minutes and ${Math.floor(currentTime % 60)} seconds`);
        console.log(this.itemId)
        // Call the API
        this.createTrack({time: currentTime});
      }
    });
  },
  methods: {
    preventForwardSeek(player) {
      if (this.isRestoringTime) {
        return;
      }

      const currentTime = player.currentTime();
      const allowedTime = this.maxAllowedTime + 1;

      if (currentTime > allowedTime) {
        this.isRestoringTime = true;
        player.currentTime(this.maxAllowedTime);
        this.openSnackbar?.('امکان جلو زدن ویدیو وجود ندارد.', '#F1416C');
        this.$nextTick(() => {
          this.isRestoringTime = false;
        });
      }
    },
    async createTrack(payload) {
      try {
        await window.axios.post('/student/tracker/create', {
          item_file_id: this.itemId,
          seconds: Math.floor(payload.time),
          type: 'video'
        });
      } catch (error) {
        console.error('Error creating track:', error);
      }
    },
    async getLastTrack() {
      try {
        const response = await window.axios.get(`/student/tracker/get/${this.itemId}`);
        const seconds = response.data.data.seconds || 0; // Default to 0 if no seconds are returned
        console.log('Last track retrieved, seconds:', seconds);
        return seconds;
      } catch (error) {
        console.error('Error fetching last track:', error);
        return 0; // Default to 0 in case of an error
      }
    }
  }
}
</script>

<style>
.video-player-container-normal {
  width: 100%;
  height: 40vh
}

.video-player-container-online-class {
  width: 100% !important;
  height: 100% !important
}

.video-player-assignment {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

video {
  border-radius: 1vw !important;
}

.video-js {
  border-radius: 1vw !important;
}

.vjs-control-bar {
  border-radius: 0 0 1.2vw 1.2vw !important;
}
</style>
